var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/clipboard-copy.ts
function makeError() {
  return new DOMException("The request is not allowed", "NotAllowedError");
}
__name(makeError, "makeError");
async function copyClipboardApi(text) {
  if (!navigator.clipboard) {
    throw makeError();
  }
  return navigator.clipboard.writeText(text);
}
__name(copyClipboardApi, "copyClipboardApi");
async function copyExecCommand(text) {
  const span = document.createElement("span");
  span.textContent = text;
  span.style.whiteSpace = "pre";
  span.style.webkitUserSelect = "auto";
  span.style.userSelect = "all";
  document.body.appendChild(span);
  const selection = window.getSelection();
  const range = window.document.createRange();
  selection?.removeAllRanges();
  range.selectNode(span);
  selection?.addRange(range);
  let success = false;
  try {
    success = window.document.execCommand("copy");
  } finally {
    selection?.removeAllRanges();
    window.document.body.removeChild(span);
  }
  if (!success) throw makeError();
}
__name(copyExecCommand, "copyExecCommand");
async function clipboardCopy(text) {
  try {
    await copyClipboardApi(text);
  } catch (err) {
    try {
      await copyExecCommand(text);
    } catch (err2) {
      throw err2 || err || makeError();
    }
  }
}
__name(clipboardCopy, "clipboardCopy");
var clipboard_copy_default = clipboardCopy;

// node_modules/@substrate-system/web-component/dist/attributes.js
var __defProp2 = Object.defineProperty;
var __name2 = /* @__PURE__ */ __name((target, value) => __defProp2(target, "name", { value, configurable: true }), "__name");
function toAttributes(attrs) {
  return Object.keys(attrs).reduce((acc, k) => {
    const value = attrs[k];
    if (!value) return acc;
    if (typeof value === "boolean") {
      if (value) return (acc + ` ${k}`).trim();
      return acc;
    }
    if (Array.isArray(value)) {
      return acc + ` ${k}="${value.join(" ")}"`;
    }
    return (acc + ` ${k}="${value}"`).trim();
  }, "");
}
__name(toAttributes, "toAttributes");
__name2(toAttributes, "toAttributes");

// src/html.ts
function CopyButton(options) {
  let classes;
  let hint;
  if (Array.isArray(options)) {
    classes = options;
  } else if (options) {
    classes = options.classes;
    hint = options.hint;
  }
  const classString = (classes || []).concat(["copy-button"]).filter(Boolean).join(" ");
  let hintHtml = "";
  if (hint !== void 0 && hint !== false) {
    const hintText = hint === true || hint === "" ? "Copied" : hint;
    hintHtml = `<span popover="manual" class="copy-hint" role="status" aria-live="polite">${hintText}</span>`;
  }
  return `<button aria-label="Copy" ${classString ? `class="${classString}"` : ""}>
        ${CopySvg()}
        <span class="visually-hidden">Copy</span>
    </button>${hintHtml}`;
}
__name(CopyButton, "CopyButton");
CopyButton.outerHTML = (options, attrs = {}) => {
  const attributes = toAttributes(attrs);
  return `<copy-button${attributes.length ? ` ${attributes}` : ""}>
        ${CopyButton(options)}
    </copy-button>`;
};
function CopySvg() {
  return `<span class="copy-wrapper">
        <svg
            aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1"
            focusable="false"
            width="16" class="copy-svg"
        >
            <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path><path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path>
        </svg>
    </span>`;
}
__name(CopySvg, "CopySvg");
function SuccessSvg() {
  return `<span class="success-wrapper">
        <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1"
            width="16"
            class="success-svg"
            focusable="false"
        >
            <path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"></path>
        </svg>
    </span>`;
}
__name(SuccessSvg, "SuccessSvg");

// node_modules/@substrate-system/web-component/dist/util.js
var __defProp3 = Object.defineProperty;
var __name3 = /* @__PURE__ */ __name((target, value) => __defProp3(target, "name", { value, configurable: true }), "__name");
function isRegistered(elName) {
  return document.createElement(elName).constructor !== window.HTMLElement;
}
__name(isRegistered, "isRegistered");
__name3(isRegistered, "isRegistered");
function define(name, element) {
  if (!window) return;
  if (!("customElements" in window)) return;
  if (!isRegistered(name)) {
    window.customElements.define(name, element);
  }
}
__name(define, "define");
__name3(define, "define");
var qs = document.querySelector.bind(document);
var qsa = document.querySelectorAll.bind(document);

// src/client.ts
var CopyButtonClient = class extends HTMLElement {
  static {
    __name(this, "CopyButtonClient");
  }
  static TAG = "copy-button";
  static observedAttributes = ["payload"];
  payload;
  hintTimeoutId;
  constructor() {
    super();
    const payload = this.getAttribute("payload");
    this.payload = payload;
  }
  /**
   * We are only observing 1 attribute, so `name` will always be 'payload'.
   */
  attributeChangedCallback(_name, _oldValue, newValue) {
    this.payload = newValue;
  }
  async clickListener() {
    if (!this.payload) return;
    const dur = this.getAttribute("duration");
    const time = dur ? parseInt(dur) : 2e3;
    try {
      await clipboard_copy_default(this.payload);
    } catch (err) {
      console.error("Copy failed:", err);
      return;
    }
    const button = this.querySelector("button");
    if (!button) {
      console.warn("CopyButtonClient: No button element found for state updates");
      return;
    }
    button.classList.add("copy-success");
    button.setAttribute("data-state", "success");
    button.innerHTML = `${SuccessSvg()}`;
    if (this.hasAttribute("hint")) {
      this.showHint(time);
    }
    await sleep(time);
    button.classList.remove("copy-success");
    button.setAttribute("data-state", "default");
    button.innerHTML = `${CopySvg()}`;
  }
  showHint(duration) {
    const hint = this.querySelector(".copy-hint");
    if (!hint) return;
    if (this.hintTimeoutId) {
      clearTimeout(this.hintTimeoutId);
    }
    hint.classList.add("copy-hint--visible");
    this.hintTimeoutId = window.setTimeout(() => {
      hint.classList.remove("copy-hint--visible");
      this.hintTimeoutId = void 0;
    }, duration);
  }
  disconnectedCallback() {
    if (this.hintTimeoutId) {
      clearTimeout(this.hintTimeoutId);
    }
    this.removeEventListener("click", this.clickListener);
  }
  connectedCallback() {
    this.render();
    this.addEventListener("click", this.clickListener);
  }
  render() {
  }
};
var client_default = CopyButtonClient;
function define2() {
  return define("copy-button", CopyButtonClient);
}
__name(define2, "define");
function sleep(n) {
  return new Promise((resolve) => setTimeout(resolve, n));
}
__name(sleep, "sleep");
export {
  CopyButtonClient,
  client_default as default,
  define2 as define
};
